import React, { createContext, useContext, useReducer } from "react";

// Context 생성
const PrayerContext = createContext();

// 초기 상태
const initialState = {
  selectedPrayer: null,
  isLoading: false,
  currentPage: "main",
};

// 액션 타입
const actionTypes = {
  SET_SELECTED_PRAYER: "SET_SELECTED_PRAYER",
  SET_LOADING: "SET_LOADING",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
};

// 리듀서 함수
const prayerReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_PRAYER:
      return {
        ...state,
        selectedPrayer: action.payload,
      };
    case actionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    default:
      return state;
  }
};

// Provider 컴포넌트
export const PrayerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(prayerReducer, initialState);

  const setSelectedPrayer = (prayer) => {
    dispatch({ type: actionTypes.SET_SELECTED_PRAYER, payload: prayer });
  };

  const setLoading = (loading) => {
    dispatch({ type: actionTypes.SET_LOADING, payload: loading });
  };

  const setCurrentPage = (page) => {
    dispatch({ type: actionTypes.SET_CURRENT_PAGE, payload: page });
  };

  const value = {
    ...state,
    setSelectedPrayer,
    setLoading,
    setCurrentPage,
  };

  return (
    <PrayerContext.Provider value={value}>{children}</PrayerContext.Provider>
  );
};

// 커스텀 훅
export const usePrayer = () => {
  const context = useContext(PrayerContext);
  if (!context) {
    throw new Error("usePrayer must be used within a PrayerProvider");
  }
  return context;
};
